import {FETCH_CONSIGNED_INVENTORY, FETCH_CONSIGNED_INVENTORY_ERROR} from '../actions/types';

const INITIAL_STATE = {
    message: '',
    erro: [],
    data: null,
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_CONSIGNED_INVENTORY:
            return {
                ...state,
                data: action.payload,
            };
        case FETCH_CONSIGNED_INVENTORY_ERROR:
            return { ...state, erro: action.payload };
        default:
            return state;
    }
}